<template>
  <div
    v-if="show"
  >
    <div
      @click="toggleAccordion()"
      class="insurance-wrap"
      :aria-expanded="isOpen"
      :aria-controls="`collapse${_uid}`"
    >
      <div
        :class="[{'active': isOpen}, 'main-info']"
      >
        <div class="ins-info item">
          <div
            class="default-text"
            v-if="!isLoadedInsurance"
          >
            {{ defaultText }}
          </div>
          <div
            class="ins-name"
            v-if="isLoadedInsurance"
          >
            {{ insuranceName }}
          </div>
        </div>
        <div class="ins-type item">
          {{ $t('preCheckIn.insuranceCard.types.' + insuranceType.toLowerCase()) }}
        </div>
        <div class="arrow item">
          <i
            class="fa fa-chevron-down"
            aria-hidden="true"
          />
        </div>
      </div>
      <div
        class="additional-info"
        v-if="!isLoadedInsurance && !active"
      >
        <div
          class="add-content"
        >
          {{ addContent }}
        </div>
      </div>
    </div>
    <div
      v-show="isOpen"
      :id="`collapse${_uid}`"
    >
      <InsuranceBlock
        :content-data="content"
        :insurance="insurance"
        :insurances="allInsurances"
        :type="insuranceType"
        :is-primary-btn="primaryButton"
        :is-secondary-btn="secondaryButton"
        :active="active"
        :is-loaded-data.sync="isLoadedInsurance"
        @passInsuranceData="updateInsuranceData"
        @render="renderPageData"
        @update="updateParam"
        @scroll="scrollToBlock"
        @nextStep="nextStep"
        ref="InsuranceBlock"
      />
    </div>
  </div>
</template>

<script>
import InsuranceBlock from '../form/InsuranceBlock';

export default {
  name: "AccordionField",
  components: {
    InsuranceBlock
  },

  data () {
    return {
      fullscreenLoading: false,
      addContent: '',
      isLoadedInsurance: false,
      insuranceName: '',
      insuranceData: {},
      allInsurances: [],
      isOpen: false,
      setPrimaryButton: false,
      setSecondaryButton: false,
    };
  },
  props: {
    insuranceType: {
      type: String, default: () => {
        return '';
      }
    },
    insurance: {
      type: Object, default: () => {
        return {};
      }
    },
    active: {
      type: Boolean, default: () => {
        return false;
      }
    },
    show: {
      type: Boolean, default: () => {
        return false;
      }
    },
    primaryButton: {
      type: Boolean, default: () => {
        return false;
      }
    },
    secondaryButton: {
      type: Boolean, default: () => {
        return false;
      }
    },
    content: {
      type: String, default: () => {
        return '';
      }
    },
    first: {
      type: String, default: () => {
        return '';
      }
    },
  },
  watch: {
    insurance: function(){
      if (!this.isObjEmpty(this.insurance) ) {
        if (Object.prototype.hasOwnProperty.call(this.insurance, 'planId') && this.insurance.frontSide && this.insurance.backSide) {
          this.$set(this, 'isLoadedInsurance', true);
          this.updateInsuranceData(this.insurance, true)
        }
      }
    }
  },
  created() {
    this.addContent = this.getInsuranceInfo();
    this.defaultText = this.$t('components.form.accordionField.defaultText');
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    },
    scrollToBlock() {
      this.$el.scrollIntoView({behavior: 'smooth', block: "center"})
      this.isOpen = true;
    },
    nextStep() {
      this.$emit('nextStep');
    },
    getInsuranceInfo() {
      let initText = this.$t('components.form.accordionField.initText', { type: this.$t('preCheckIn.insuranceCard.types.' + this.insuranceType.toLowerCase()) }),
          addText = this.$t('components.form.accordionField.addText', { type: this.$t('preCheckIn.insuranceCard.types.' + this.insuranceType.toLowerCase()) });

      return this.active ? initText : addText;
    },
    updateParam() {
      this.$set(this, 'isLoadedInsurance', false);
    },
    updateInsuranceData(data, load = false) {
      this.$set(this, 'insuranceName', load ? data.planName : data.insuranceName);
      this.$set(this, 'isLoadedInsurance', true);
      if (typeof data.insuranceType !== 'undefined') this.$emit('updateData', data.insuranceType);
    },
    setInsurances(all) {
      this.$set(this, 'allInsurances', all);
    },
    renderPageData(args){
      this.$emit('renderData', args);
    }
  }
}
</script>
